<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Company' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label>{{'Company name' | translate}}</label>
      <input class="form-control" autocomplete="off" [(ngModel)]="entity.companyName" />
    </div>

    <div class="form-group">
      <label>{{'Registration number' | translate}}</label>
      <input class="form-control" autocomplete="off" [(ngModel)]="entity.registrationNumber" />
    </div>

    <h3>{{'Contact person' | translate}}</h3>

    <div class="form-group">
      <label>{{'Email' | translate}}</label>
      <input class="form-control" autocomplete="off" [(ngModel)]="entity.emailAddress" />
    </div>

    <div class="form-group">
      <label>{{'First name' | translate}}</label>
      <input class="form-control" autocomplete="off" [(ngModel)]="entity.firstName" />
    </div>

    <div class="form-group">
      <label>{{'Last name' | translate}}</label>
      <input class="form-control" autocomplete="off" [(ngModel)]="entity.lastName" />
    </div>

    <h3>{{'Address' | translate}}</h3>

    <div class="row">

      <div class="col-sm-8">
        <div class="form-group">
          <label>{{'Street' | translate}}</label>
          <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.visitAddress.street" />
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{'No.' | translate}}</label>
          <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.visitAddress.number" />
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{'Addition' | translate}}</label>
          <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.visitAddress.numberSuffix" />
        </div>
      </div>

      <div class="col-sm-8">
        <div class="form-group">
          <label>{{'City' | translate}}</label>
          <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.visitAddress.city" />
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label>{{'Postal code' | translate}}</label>
          <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.visitAddress.postalCode" />
        </div>
      </div>

      <div class="col-12">

        <div class="form-group">
          <label>{{'Country' | translate}}</label>
          <select class="form-control" autocomplete="off" [(ngModel)]="entity.visitAddress.country">
            <option *ngFor="let option of locale.availableCountries()" [value]="option.code">{{option.name}}</option>
          </select>
        </div>

      </div>

    </div>

    <h3>{{'Email notifications' | translate}}</h3>
    <div class="form-group">
      <div class="custom-control custom-checkbox">
        <input class="custom-control-input" id="allowEmailNotifications" type="checkbox" [(ngModel)]="entity.allowEmailNotifications" />
        <label class="custom-control-label" for="allowEmailNotifications">{{'I want to get email notifications' | translate}}</label>
      </div>
    </div>

    <div class="form-group">
      <div class="custom-control custom-checkbox">
        <input class="custom-control-input" id="isSubscribedToNewsletter" type="checkbox" [(ngModel)]="entity.isSubscribedToNewsletter" />
        <label class="custom-control-label" for="isSubscribedToNewsletter">{{'I want to receive newsletters' | translate}}</label>
      </div>
    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="registerCompany()">{{'Register' | translate}}</button>
    </div>
  </div>
</div>
